import { localManufacturerImage } from "@/data/localManufacturerImages";
export type OldeWoodReclaimedProduct = {
  name: string;
  species: string;
  img: string;
  href: string;
};

export const reclaimedProducts: OldeWoodReclaimedProduct[] = [
  {
    name: "Antique Reclaimed Oak",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/reclaimed-antique-oak.websitetest.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-oak-flooring",
  },
  {
    name: "Reclaimed Oak  Appearance Grade White Oak",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-oak-white.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-oak-appearance-grade-white-oak",
  },
  {
    name: "Reclaimed Oak Hit-Skip",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-oak-hitskip-owl7-nat-oil-9-490x400-cypress-hollowa-watermarked.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-oak-hit-skip",
  },
  {
    name: "Reclaimed Resawn Oak",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-oak-resawn-1.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-resawn-oak",
  },
  {
    name: "Reclaimed Resawn Oak  Appearance Grade White Oak",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/thumbnailresawnappearancegradewhiteoakkitchen.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-resawn-oak-appearance-grade-white-oak",
  },
  {
    name: "Reclaimed Oak  Original Face",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/thumbnailoakoriginalfacerestaurant.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-oak-original-face",
  },
  {
    name: "Reclaimed Historic Plank",
    species: "Mixed Hardwood",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/historic-listing.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-historic-plank",
  },
  {
    name: "Reclaimed Harvest Plank",
    species: "Mixed Hardwood",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/harvest-listing-1.png"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-harvest-plank",
  },
  {
    name: "Reclaimed Hickory",
    species: "Hickory",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-hickory.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-hickory",
  },
  {
    name: "Reclaimed Beech/Maple",
    species: "Beech/Maple",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/thumbnailbeechmaplecafe-1.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-beechmaple",
  },
  {
    name: "Reclaimed Wormy Chestnut",
    species: "Chestnut",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-chestnut-highres-8125-owl5-2-wm-cropped.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-wormy-chestnut",
  },
  {
    name: "Reclaimed White Pine",
    species: "Pine",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-white-pine.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-white-pine",
  },
  {
    name: "Reclaimed Tobacco Pine",
    species: "Pine",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/thumbnailtobaccopinelivingroom-1.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-tobacco-pine",
  },
  {
    name: "Reclaimed Heart Pine Hit-Skip",
    species: "Heart Pine",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-heart-pine-hitskipflooringpagelistingimage-highres-copy.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-heart-pine-hit-skip",
  },
  {
    name: "Reclaimed Heart Pine  Select",
    species: "Heart Pine",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-heartpine-select-wm-498x400.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-heart-pine-select",
  },
  {
    name: "Reclaimed Heart Pine  Common",
    species: "Heart Pine",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/thumbnailantiquereclaimedheartpinecommongradelivingroom.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-heart-pine-common",
  },
  {
    name: "Reclaimed Heart Pine  Original Face",
    species: "Heart Pine",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/heart-pine-original-face-listing.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-heart-pine-original-face",
  },
  {
    name: "Reclaimed Trophy Room",
    species: "Mixed Hardwood",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-trophy-room.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-trophy-room",
  },
  {
    name: "Reclaimed Oak Trophy Room",
    species: "Oak",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-trophy-oak.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-oak-trophy-room",
  },
  {
    name: "Reclaimed Douglas Fir",
    species: "Douglas Fir",
    img: localManufacturerImage("https://www.oldewoodltd.com/uploads/ant-thumb-douglas-fir.jpg"),
    href: "https://www.oldewoodltd.com/products/reclaimed-flooring/antique-reclaimed-douglas-fir",
  },
];

export const reclaimedSpecies = Array.from(new Set(reclaimedProducts.map(p => p.species)));
